import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import CardPlan from '@anm/components/subscription/current-plan/CardPlan';
import getPeriodName from '@anm/helpers/subscription/getPeriodName';
import { FC } from 'react';

export type CurrentStaffPlanProps = {
  period: SubscriptionPeriod;
  planName: string;
};

const CurrentStaffPlan: FC<CurrentStaffPlanProps> = ({ period, planName }) => (
  <CardPlan plan={planName} periodName={getPeriodName(period)}></CardPlan>
);

export default CurrentStaffPlan;
